import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectTimesheetHolidaysGroupedByDate } from 'services/timesheetHolidays/selectors';
import { selectEntities } from 'services/entities/selectors';
import { TimesheetHolidayDate } from 'services/timesheetHolidays/types';
import { EntityId } from 'services/entities/types';
import { AppState } from 'services/types';
import { findEntityHolidayByDate } from 'services/timesheetHolidays/utils';

import { OwnProps } from './index';

const selectTimesheetDate = (
    state: AppState,
    props: OwnProps
): TimesheetHolidayDate => props.timesheetDate;
const selectTimesheetEntityId = (
    state: AppState,
    props: OwnProps
): EntityId | undefined => props.timesheetEntityId;

const selectTimesheetIsHoliday = createDeepEqualSelector(
    selectTimesheetDate,
    selectTimesheetEntityId,
    selectTimesheetHolidaysGroupedByDate,
    selectEntities,
    (
        timesheetDate,
        timesheetEntityId,
        timesheetHolidaysGroupedByDate,
        entities
    ) => {
        if (timesheetEntityId) {
            return Boolean(
                findEntityHolidayByDate(
                    timesheetDate,
                    timesheetEntityId,
                    timesheetHolidaysGroupedByDate,
                    entities
                )
            );
        }

        return false;
    }
);

const makeSelectTimesheetIsHoliday = (): typeof selectTimesheetIsHoliday =>
    selectTimesheetIsHoliday;

export {
    selectTimesheetDate,
    selectTimesheetEntityId,
    makeSelectTimesheetIsHoliday
};
